<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmBtod">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      btod_encrid: null,
      btod_tabel: null
    }
  },
  methods: {
    open(btod_tabel,btod_encrid) {
       this.btod_tabel = btod_tabel;
       this.btod_encrid = btod_encrid;
       this.dialog = true;
    },
    rmBtod() { 
      this.$axios
        .post("ares/json/ares/task/fin/abn/rmBtod.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmBtod"
          },
          rmBtod: {
            btod_tabel: this.btod_tabel,
            btod_encrid: this.btod_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/task/fin/abn/searchBtodNew'); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmBtod.text,
              color: res.data.rmBtod.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

